// SERENISMM brand system — warm boutique palette + approved assets.
// Palette (warm, luminous — the physical maison):
//  ivory #F3EEE4 · sand #E8DFCF · stone #D8CCB6 · card #FBF8F1 · border #DCD1BC
//  ink #2E2A22 · ink-soft #6B6151 · muted #9C907A · accent(champagne) #A98F63 · contrast #201C15

export const ASSETS = {
  boutique: "https://static.prod-images.emergentagent.com/jobs/ca3e1487-2e53-4d24-906c-c42bf5b5dc02/images/4d256692dfac23f2863f982595acda09900fcfc9ff3447efbd7cd502e137b71a.jpeg",
  sereneHeart: "https://static.prod-images.emergentagent.com/jobs/ca3e1487-2e53-4d24-906c-c42bf5b5dc02/images/105d1aa8a4f40d60f7f6ec4172df33e6957aa31604bdd6b6d1c38affe4df8126.jpeg",
  editorial: "https://static.prod-images.emergentagent.com/jobs/ca3e1487-2e53-4d24-906c-c42bf5b5dc02/images/4167ecdb71ad71b6ee3cfe406391ff9eedcd40207d311d57ae07de958c6669b5.jpeg",
  journal: "https://static.prod-images.emergentagent.com/jobs/ca3e1487-2e53-4d24-906c-c42bf5b5dc02/images/56fcd659becc74ea71484a3447a73d97d3df421a5db34fde35136e00b235d06d.jpeg",
  world: "https://static.prod-images.emergentagent.com/jobs/ca3e1487-2e53-4d24-906c-c42bf5b5dc02/images/464a4e34ba5f28cab5ed51277b01286c2db382484b8d07a390093b9ffdc95db7.jpeg",
  storePhoto: "https://customer-assets-rejwkqb3.emergentagent.net/job_private-members-1/artifacts/g43hwm62_file_00000000ea68720b867b547486dde1ed.webp",
};

export function SereneHeart({ size = 28, tone = "champagne", className = "" }) {
  return (
    <img
      src={`/brand/mark-${tone}.png`}
      alt="The Serene Heart"
      className={`block ${className}`}
      style={{ height: size, width: "auto" }}
    />
  );
}

export function Wordmark({ height = 24, tone = "ink", className = "", testid }) {
  return (
    <img src={`/brand/word-${tone}.png`} alt="SERENISMM" data-testid={testid}
      className={`block ${className}`} style={{ height, width: "auto" }} />
  );
}

export function Lockup({ height = 120, tone = "ink", className = "" }) {
  return (
    <img src={`/brand/lockup-${tone}.png`} alt="SERENISMM"
      className={`block ${className}`} style={{ height, width: "auto" }} />
  );
}

